import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import BirForm from '../BirForm/BirForm';
import countryData from './countryData.json';
import { prefixFieldIds, getFieldHierarchy } from '../BirForm/utils/fieldId';
import { transformFieldListValues } from '../BirForm/utils/listValues';
import processFieldConditions from '../BirForm/utils/condition/processFieldConditions';
import './index.css';

var BirFormContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(BirFormContainer, _Component);

  function BirFormContainer(props) {
    var _this;

    _classCallCheck(this, BirFormContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BirFormContainer).call(this, props));

    _this.componentDidMount = function () {
      _this.changeForm(_this.props.country);
    };

    _this.componentDidUpdate = function (prevProps) {
      var country = _this.props.country;

      if (prevProps.country !== country) {
        _this.changeForm(country);
      }
    };

    _this.processFields = function (fields) {
      prefixFieldIds(fields);
      transformFieldListValues(fields);
      processFieldConditions(fields);
    };

    _this.changeForm = function (selectedCountry) {
      try {
        var fields = countryData[selectedCountry];

        _this.processFields(fields);

        _this.setState({
          fields: fields,
          fieldsHierarchy: getFieldHierarchy(fields)
        });
      } catch (e) {
        console.log(e);
      }
    };

    _this.renderOptions = function () {
      return _this.options.map(function (item, index) {
        return React.createElement('option', {
          key: index
        }, item.label);
      });
    };

    _this.state = {
      fields: [],
      fieldsHierarchy: []
    };
    _this.handleDebouncedChange = _.debounce(props.onChange, 500);
    return _this;
  }

  _createClass(BirFormContainer, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          fields = _this$state.fields,
          fieldsHierarchy = _this$state.fieldsHierarchy;
      var _this$props = this.props,
          initialValues = _this$props.initialValues,
          onSubmit = _this$props.onSubmit,
          onStepSubmit = _this$props.onStepSubmit,
          uploadingFiles = _this$props.uploadingFiles,
          files = _this$props.files,
          currentStep = _this$props.currentStep,
          hideSubmitButton = _this$props.hideSubmitButton,
          country = _this$props.country,
          language = _this$props.language;

      if (!fields || !fields.length) {
        return null;
      }

      return React.createElement('div', {
        className: 'GeneratedForm'
      }, React.createElement(BirForm, {
        fields: fields,
        fieldsHierarchy: fieldsHierarchy,
        initialValues: initialValues,
        handleChange: this.handleDebouncedChange,
        handleFinalSubmit: onSubmit,
        onStepSubmit: onStepSubmit,
        currentStepTitle: currentStep,
        uploadingFiles: uploadingFiles,
        files: files,
        hideSubmitButton: hideSubmitButton,
        country: country,
        language: language
      }));
    }
  }]);

  return BirFormContainer;
}(Component);

BirFormContainer.propTypes = {
  initialValues: PropTypes.object,
  country: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  language: PropTypes.string,
  currentStep: PropTypes.string,
  hideSubmitButton: PropTypes.bool
};
BirFormContainer.defaultProps = {
  hideSubmitButton: false,
  language: 'en'
};
export default BirFormContainer;